module.exports = __webpack_public_path__ + "02_glasses_blue.d0e1f1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/02_glasses_blue.png
// module id = vjaa
// module chunks = 0